import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin, pairwise, startWith, Subscription } from 'rxjs';
import { generateUUID } from 'src/app/core/generators/generateUUID';
import { validarIsNullOrEmpty } from 'src/app/core/utils/utilities';
import {
  ICreateAgendamento,
  IEditAgendamento,
  IGetAgendamentoById
} from 'src/app/services/AgendamentoService/agendamento.model';
import { AgendamentoService } from 'src/app/services/AgendamentoService/agendamento.service';
import { IGetCaminhaoResponse } from 'src/app/services/CaminhaoService/caminhao.model';
import { CaminhaoService } from 'src/app/services/CaminhaoService/caminhao.service';
import { IItems as IItemsCarreta } from 'src/app/services/CarretaService/carreta.model';
import { CarretaService } from 'src/app/services/CarretaService/carreta.service';
import { IItems as ItemsCavalo } from 'src/app/services/CavaloService/cavalo.model';
import { CavaloService } from 'src/app/services/CavaloService/cavalo.service';
import { IResponseGetEmpresaById } from 'src/app/services/EmpresaService/empresa.model';
import { EmpresaService } from 'src/app/services/EmpresaService/empresa.service';
import { AppExportBase64 } from 'src/app/services/ExportBase64/exportBase64.service';
import { IItems as IItemsMotorista } from 'src/app/services/MotoristaService/motorista.model';
import { MotoristaService } from 'src/app/services/MotoristaService/motorista.service';
import { IGetPrecoResponse } from 'src/app/services/PrecoService/preco.model';
import { PrecoService } from 'src/app/services/PrecoService/preco.service';
import { IGetServicoResponse } from 'src/app/services/ServicoService/servico.model';
import { ServicoService } from 'src/app/services/ServicoService/servico.service';
import { SwalAlertService } from 'src/app/services/SwalAlertService/swalAlert.service';
import Swal from 'sweetalert2';

type IOptions = {
  name: string;
  value: string | number;
  listaIndex?: number;
};

@Component({
  selector: 'app-cadastro-agendamento',
  templateUrl: './cadastro-agendamento.component.html',
  styleUrls: ['./cadastro-agendamento.component.scss']
})
export class CadastroAgendamentoComponent
  implements OnInit, OnDestroy, OnChanges, AfterViewInit
{
  private subscription$ = new Subscription();
  disabledAgendamento: boolean = true;
  visible: boolean = false;
  form: FormGroup;
  title: string = 'Cadastro de Agendamento';
  isLoading: boolean = false;
  guid: string = generateUUID();
  statusInput: boolean = false;
  activeRoute: string = '';
  idAgendamento: number = 0;
  valorServico: string = '7,00';
  servicoOptions: IOptions[] = [
    {
      name: '',
      value: ''
    }
  ];

  carretaOptions1: IOptions[] = [
    {
      name: '',
      value: ''
    }
  ];

  carretaOptions2: IOptions[] = [
    {
      name: '',
      value: ''
    }
  ];

  carretaOptions3: IOptions[] = [
    {
      name: '',
      value: ''
    }
  ];

  motoristaOptions: IOptions[] = [
    {
      name: '',
      value: ''
    }
  ];

  cavaloOptions: IOptions[] = [
    {
      name: '',
      value: ''
    }
  ];

  copiedCarretaOptions1: IOptions[] = [];
  copiedCarretaOptions2: IOptions[] = [];
  copiedCarretaOptions3: IOptions[] = [];
  valueRemove: IOptions[] = [];
  idCaminhao: number = 0;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private cd: ChangeDetectorRef,
    private agendamentoService: AgendamentoService,
    private servicoService: ServicoService,
    private motoristaService: MotoristaService,
    private cavaloService: CavaloService,
    private carretaService: CarretaService,
    private precoService: PrecoService,
    private empresaService: EmpresaService,
    private caminhaoService: CaminhaoService,
    private swalAlert: SwalAlertService
  ) {
    this.form = this._inicializarFormulario();
  }

  private _inicializarFormulario() {
    const form = this.fb.group({
      FK_SRVC: [0, [Validators.required]],
      DT_AGND: ['', [Validators.required]],
      FK_MTRT_EPSA: [0, [Validators.required]],
      NM_MTRT: [''],
      FK_CAVA: [0, [Validators.required]],
      FK_CRRT_1: [0],
      FK_CRRT_2: [0],
      FK_CRRT_3: [0],
      TX_OBSV_AGND: ['']
    });
    return form;
  }

  ngOnInit(): void {
    const status = this.statusAgendamento();

    const observables = [
      this.getServico(status),
      this.getMotorista(status),
      this.getPlacaCavalo(status),
      this.getPlacaCarreta(status)
    ];

    forkJoin(observables).subscribe(() => {
      this.stateForms();
    });

    const nome = localStorage.getItem('nome');
    this.form.controls['NM_MTRT'].setValue(nome);
    this.form.controls['NM_MTRT'].disable();
  }

  ngAfterViewInit(): void {}

  statusAgendamento(): number {
    let status: number = 1;

    this.route.queryParams.subscribe(params => {
      if (Object.keys(params).length === 0) {
        status = 1;
      } else {
        this.title = 'Editar Agendamento';
        this.disabledAgendamento = false;
        this.visible = true;
        this.idAgendamento = Number(params['codigo']);
        this.form.get('FK_SRVC')?.disable();

        if (params['modoAgendamento'] == 'Visualizar') {
          this.title = 'Visualização de Agendamento';
          this.statusInput = true;
          this.form.disable();
          this.disabledAgendamento = true;
          status = 2;
        }
      }
    });

    return status;
  }

  async stateForms() {
    if (this.idAgendamento !== 0)
      this.agendamentoService
        .GetAgendamentoById(this.idAgendamento)
        .subscribe((response: IGetAgendamentoById) => {
          this.form.controls['DT_AGND'].setValue(
            String(response.DT_AGND) ?? ''
          );
          this.caminhaoService
            .GetCaminhaoByAgendamento(this.idAgendamento)
            .subscribe((res: IGetCaminhaoResponse) => {
              this.form.controls['FK_MTRT_EPSA'].setValue(
                res.FK_MTRT_EPSA ?? 0
              );
              this.form.controls['FK_CAVA'].setValue(res.FK_CAVA ?? 0);
              this.form.controls['FK_CRRT_1'].setValue(res.FK_CRRT_1 ?? 0);
              this.form.controls['FK_CRRT_2'].setValue(res.FK_CRRT_2 ?? 0);
              this.form.controls['FK_CRRT_3'].setValue(res.FK_CRRT_3 ?? 0);
              this.idCaminhao = Number(res.PK_CMNH);
            });
          this.form.controls['FK_SRVC'].setValue(response.FK_SRVC ?? 0);
          this.form.controls['TX_OBSV_AGND'].setValue(response.TX_OBSV_AGND);
        });
  }

  createPayload(): ICreateAgendamento | IEditAgendamento {
    return {
      DT_AGND: this.form.controls['DT_AGND'].value,
      NU_STTS_AGND: 1,
      FK_MTRT_EPSA: 0,
      FK_MTRT_EXTR: Number(localStorage.getItem('id')),
      FK_CAVA: Number(this.form.controls['FK_CAVA'].value),
      FK_CRRT_1: Number(this.form.controls['FK_CRRT_1'].value),
      FK_CRRT_2: Number(this.form.controls['FK_CRRT_2'].value),
      FK_CRRT_3: Number(this.form.controls['FK_CRRT_3'].value),
      TX_OBSV_AGND: String(this.form.controls['TX_OBSV_AGND'].value),
      FK_SRVC: Number(this.form.controls['FK_SRVC'].value)
    };
  }

  postarDados() {
    if (this.form.valid) {
      this.isLoading = true;

      let payload = this.createPayload();
      if (this.title.includes('Editar')) {
        payload = {
          ...this.createPayload(),
          FK_CMNH: this.idCaminhao
        };

        this.agendamentoService
          .EditarAgendamentoEmpresa(this.idAgendamento, payload)
          .subscribe(
            () => {
              this.router.navigate(['/listagem/agendamento']);
              this.isLoading = false;
            },
            () => {
              this.isLoading = false;
            }
          );
      } else if (this.title.includes('Cadastro')) {
        this.agendamentoService
          .CreateAgendamentoEmpresa(payload, this.guid)
          .subscribe(
            response => {
              const queryParams = {
                PK_AGND: response.PK_AGND,
                VL_SRVC: this.valorServico
              };

              this.router.navigate(['pagamento'], {
                queryParams: queryParams
              });

              this.isLoading = false;
            },
            () => {
              this.isLoading = false;
            }
          );
      }
    } else {
      this.swalAlert.showAlert(
        'Atenção',
        'Verifique se todos os campos obrigatórios foram preenchidos corretamenta.',
        'warning',
        false,
        false,
        undefined
      );
    }
  }

  public goTo(route: string) {
    this.router.navigate([route]);
    setTimeout(() => {
      this.activeRoute = this.router.url;
      this.cd.detectChanges();
    }, 200);
  }

  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }

  async getServico(status: number): Promise<void> {
    this.isLoading = true;

    try {
      const response: IGetServicoResponse[] = await this.servicoService
        .GetServico(true)
        .toPromise();

      this.servicoOptions = response.map(x => ({
        name: x.TX_TIPO_SRVC,
        value: x.PK_SRVC
      }));
    } catch (error) {
      console.error('Erro ao buscar serviços:', error);
    } finally {
      this.isLoading = false;
    }
  }

  async getMotorista(status: number): Promise<void> {
    this.isLoading = true;

    try {
      const response = await this.motoristaService
        .GetMotoristaEmpresa({ paginar: false, status: status })
        .toPromise();

      this.motoristaOptions = response.ITEMS.map((x: IItemsMotorista) => ({
        name: x.NM_USUA_MTRT,
        value: x.PK_MTRT
      }));
    } catch (error) {
      console.error('Erro ao buscar motoristas:', error);
    } finally {
      this.isLoading = false;
    }
  }

  async getPlacaCavalo(status: number): Promise<void> {
    this.isLoading = true;

    try {
      const response = await this.cavaloService
        .GetCavalo({ paginar: false, status: status })
        .toPromise();

      this.cavaloOptions = response.ITEMS.map((x: ItemsCavalo) => ({
        name: x.TX_PLCA_CAVA,
        value: x.PK_CAVA
      }));
    } catch (error) {
      console.error('Erro ao buscar placas de cavalo:', error);
    } finally {
      this.isLoading = false;
    }
  }

  async getPlacaCarreta(status: number): Promise<void> {
    this.isLoading = true;

    try {
      const response = await this.carretaService
        .GetCarreta({ paginar: false, status: status })
        .toPromise();

      this.carretaOptions1 = response.ITEMS.map((x: IItemsCarreta) => ({
        name: x.TX_PLCA_CRRT,
        value: x.PK_CRRT
      }));
      this.carretaOptions2 = response.ITEMS.map((x: IItemsCarreta) => ({
        name: x.TX_PLCA_CRRT,
        value: x.PK_CRRT
      }));
      this.carretaOptions3 = response.ITEMS.map((x: IItemsCarreta) => ({
        name: x.TX_PLCA_CRRT,
        value: x.PK_CRRT
      }));

      this.copiedCarretaOptions1 = [...this.carretaOptions1];
      this.copiedCarretaOptions2 = [...this.carretaOptions2];
      this.copiedCarretaOptions3 = [...this.carretaOptions3];
    } catch (error) {
      console.error('Erro ao buscar placas de carreta:', error);
    } finally {
      this.isLoading = false;
    }
  }

  atualizarCampo(campo: string, valor: any): void {
    if (this.form.controls[campo].value !== valor) {
      this.form.controls[campo].setValue(valor);
    }
  }

  escolherOpcao(campo: string, options: any[], value: any): void {
    const selecionado = options.find(opcao => opcao?.value === Number(value));

    this.atualizarCampo(campo, selecionado?.value);
  }

  escolherServico(value: any): void {
    this.escolherOpcao('FK_SRVC', this.servicoOptions, value);
    this.visible = false;

    if (!validarIsNullOrEmpty(value)) {
      this.precoService
        .GetPrecoAgendamentoByServico(Number(value))
        .subscribe((response: IGetPrecoResponse) => {
          // const responseValor = response.ITEMS;

          if (response == null) {
            this.swalAlert.showAlert(
              'Atenção',
              'Ocorreu uma falha para consultar o valor do serviço, por favor, escolha outra opção.',
              'warning',
              false,
              false,
              undefined
            );
          } else {
            this.visible = true;
            this.valorServico = this.formatarParaReal(
              String(response.preco.VL_SRVC)
            );
          }
        });
    }
  }

  escolherMotorista(value: any): void {
    this.escolherOpcao('FK_MTRT_EPSA', this.motoristaOptions, value);
  }

  escolherPlacaCarreta(value: any, input: number): void {
    const carretasOptions = [
      this.carretaOptions1,
      this.carretaOptions2,
      this.carretaOptions3
    ];

    carretasOptions.forEach((carreta, index) => {
      if (index === input - 1) {
        this.escolherOpcao(`FK_CRRT_${input}`, carreta, value);
      } else {
        this.form.controls[`FK_CRRT_${input}`].valueChanges
          .pipe(startWith(null), pairwise())
          .subscribe(([prev, next]: [any, any]) => {
            const current = carreta.find(
              opcao => opcao?.value === Number(next)
            );

            const previous = this.valueRemove.find(
              opcao => opcao?.value === Number(prev)
            );

            if (current) {
              const indexToRemove = carreta.indexOf(current);
              if (indexToRemove !== -1) {
                carreta.splice(indexToRemove, 1);
              }
              this.valueRemove.push(current);
            }

            if (previous) {
              const indexToRemove = this.valueRemove.indexOf(previous);
              if (indexToRemove !== -1) {
                this.valueRemove.splice(indexToRemove, 1);
              }
            }
          });
      }
    });
  }

  escolherPlacaCavalo(value: any): void {
    this.escolherOpcao('FK_CAVA', this.cavaloOptions, value);
  }

  formatarParaReal(value: string): string {
    const valueFormate = value.replace('.', ',');

    const partes = valueFormate.split(',');

    const parteInteira = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const parteDecimal = partes[1] ? `,${partes[1]}` : ',00';

    return `${parteInteira}${parteDecimal}`;
  }

  consultarValor() {
    this.visible = false;

    if (this.form.valid && !this.title.includes('Visualizar')) {
      this.disabledAgendamento = !this.form.valid;
      this.visible = true;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {}
}
